import { styled } from 'goober';
import { ComponentChildren } from 'preact';

const Container = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
`;

interface HeaderActionsProps {
  children: ComponentChildren;
}

export function HeaderActions({ children }: HeaderActionsProps) {
  return <Container>{children}</Container>;
}
